import { createBrowserHistory } from 'history';
import { ROOT } from 'constants/global';
import { Store } from 'redux';
import generateRouter from './generateRouter';
import routerConfig from './router.config';

export const history = createBrowserHistory({
  basename: ROOT,
});

export function getRoutes(store: Store) {
  return generateRouter(routerConfig);
}
